module.exports = "/static/images/envelope-regular.svg";